import React from 'react';

const MarketingPreferencesConsent = ({
  emailOptIn,
  smsOptIn,
  onEmailChange,
  onSmsChange,
  disabled = false,
  idPrefix = 'marketing',
  showTitle = true,
  className = '',
  checkboxClassName = 'h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500',
  labelClassName = 'text-sm text-gray-700 cursor-pointer',
  bodyClassName = 'text-sm text-gray-600 leading-relaxed',
}) => {
  const emailId = `${idPrefix}_email_opt_in`;
  const smsId = `${idPrefix}_sms_opt_in`;

  return (
    <div className={className}>
      {showTitle && (
        <h3 className="text-base font-semibold text-gray-900 mb-3">
          Marketing Preferences (Optional)
        </h3>
      )}

      <div className={`space-y-3 ${bodyClassName}`}>
        <p>
          I would like to receive information about job opportunities, careers events,
          networking events, market insights, employer content and other relevant
          communications from Dartmouth Partners, other companies within the Kernel Limited
          group, and selected third-party organisations and clients whose opportunities,
          events or services may be relevant to me.
        </p>
        <p>
          By opting in, I understand that my contact details and communication preferences
          may be used by Dartmouth Partners and other Kernel Limited companies to send these
          communications, including communications on behalf of selected clients and partner
          organisations. My personal data will not be sold to third parties.
        </p>
        <p>
          I understand that I can withdraw my consent or update my preferences at any time
          through my account settings, by using the unsubscribe link included in
          communications, or by emailing{' '}
          <a
            href="mailto:privacy@kernel-global.com"
            className="text-blue-600 hover:underline"
          >
            privacy@kernel-global.com
          </a>
          .
        </p>
      </div>

      <div className="flex flex-col gap-3 mt-4">
        <div className="flex items-start space-x-3">
          <input
            id={emailId}
            type="checkbox"
            checked={emailOptIn}
            disabled={disabled}
            onChange={(e) => onEmailChange?.(e.target.checked)}
            className={`${checkboxClassName} mt-0.5 shrink-0`}
          />
          <label htmlFor={emailId} className={labelClassName}>
            Email marketing consent
          </label>
        </div>
        <div className="flex items-start space-x-3">
          <input
            id={smsId}
            type="checkbox"
            checked={smsOptIn}
            disabled={disabled}
            onChange={(e) => onSmsChange?.(e.target.checked)}
            className={`${checkboxClassName} mt-0.5 shrink-0`}
          />
          <label htmlFor={smsId} className={labelClassName}>
            SMS marketing consent
          </label>
        </div>
      </div>

      <p className={`mt-4 ${bodyClassName}`}>
        By selecting this option, you agree that Dartmouth Partners and other Kernel Limited
        companies may contact you with marketing communications and may send communications
        on behalf of carefully selected clients, employers and event partners.
      </p>
    </div>
  );
};

export default MarketingPreferencesConsent;
